import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  Icon,
  ScrollArea,
} from "@elaniintc/goes-design-system";
import { DropdownMenuSeparator } from "@radix-ui/react-dropdown-menu";
import type { FieldTypeName } from "../../types";

// value must match FieldTypeName in src/pages/digital-files/types.ts

const groupedFieldTypes = [
  {
    label: null,
    items: [
      { value: "text", label: "Campo de texto", icon: "text" },
      { value: "number", label: "Campo numérico", icon: "hashtag" },
      {
        value: "textarea",
        label: "Área de texto (párrafo)",
        icon: "paragraph",
      },
      {
        value: "select",
        label: "Lista de selección",
        icon: "list",
      },
    ],
  },
  {
    label: "Tiempo",
    items: [
      { value: "date", label: "Fecha y hora", icon: "calendar-clock" },
      { value: "date_range", label: "Rango de fechas", icon: "calendars" },
    ],
  },
  {
    label: "Datos",
    items: [
      { value: "email", label: "Correo electrónico", icon: "envelope" },
      { value: "phone", label: "Número telefónico", icon: "phone" },
      { value: "identification", label: "Identificación", icon: "id-card" },
      { value: "file", label: "Subida de archivos", icon: "file-arrow-up" },
    ],
  },
];

export default function FieldDropdown({
  onAdd,
}: Readonly<{
  onAdd: (type: FieldTypeName) => void;
}>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="tertiary"
          size="sm"
          className="text-body-loud font-semibold text-sm"
        >
          Añadir campo <Icon type="far" name="plus" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="rounded-lg border border-neutral bg-neutral-object shadow-lg h-full w-66"
        side="right"
        align="start"
      >
        <ScrollArea className="h-63.5">
          {groupedFieldTypes.map((group) => (
            <div className="flex flex-col" key={group.label || "text"}>
              {group.label && (
                <div className="flex items-center gap-2 px-3 py-1">
                  <span className="text-xs text-body-quiet font-semibold  tracking-wide">
                    {group.label}
                  </span>
                  <DropdownMenuSeparator className="border-neutral-quiet border-t flex-1" />
                </div>
              )}
              {group.items.map((ft) => (
                <DropdownMenuItem
                  key={ft.value}
                  className="flex items-center gap-4 px-3 py-2 rounded-md text-body hover:bg-neutral-object-accent-silent cursor-pointer"
                  onClick={() => onAdd(ft.value as FieldTypeName)}
                >
                  <Icon
                    type="far"
                    name={ft.icon}
                    className="text-body-quiet text-base w-4"
                  />
                  <span className="text-body text-base">{ft.label}</span>
                </DropdownMenuItem>
              ))}
            </div>
          ))}
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
